<template>
    <div class="steps">
      <step-button
        v-for="(singleStep, index) in steps"
        :key="index"
        :index="index + 1"
        :label="singleStep"
        :active="index + 1 | isActive(step)"
        :disabled="index + 1 | isDisabled(step)"
        @change-step="step = index + 1"
      />
    </div>
</template>

<script>
import StepButton from './StepButton'

export default {
  filters: {
    isActive: function(index, step) {
      return index === step
    },
    isDisabled: function(index, step) {
      return index > step
    }
  },

  components: {
    StepButton
  },

  props: {
    value: {
      type: Number,
      required: false
    },
    steps: {
      type: Array,
      required: true
    }
  },

  computed: {
    step: {
      get() {
        return this.value
      },
      set(newValue) {
        return this.$emit('input', newValue)
      }
    }
  }
}
</script>

<style lang="scss">
.steps {
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  width: 100%;
}
</style>
